import { render, staticRenderFns } from "./StockTagPicker.vue?vue&type=template&id=3315129e"
import script from "./StockTagPicker.vue?vue&type=script&lang=js"
export * from "./StockTagPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports